const INTITIAL_STATE = {}

const rootReducer = (state=INTITIAL_STATE, action) => {
    return state
}

export default rootReducer